<script>
import {getUrlParameter, setUrlParam} from "@/baseUtils";
import {mapActions, mapState} from "pinia";
import {baseLoaderStore} from "@/store/baseLoaderStore";
import {proposalStore} from "@/store/proposalStore";
import {bankIdStore} from "@/store/bankIdStore";
import {editProposalStore} from "@/store/editProposalStore";
import EditProposalGeneralInfo from "@/views/proposal/proposal-edit/EditProposalGeneralInfo.vue";
import EditProposalEnterActual from "@/views/proposal/proposal-edit/EditProposalEnterActual.vue";
import EditProposalArguments from "@/views/proposal/proposal-edit/EditProposalArguments.vue";
// import EditProposalSubjects from "@/views/proposal/proposal-edit/EditProposalSubjects.vue";
import EditProposalImportance from "@/views/proposal/proposal-edit/EditProposalImportance.vue";
// import EditProposalThumbnail from "@/views/proposal/proposal-edit/EditProposalThumbnail.vue";
import ActualProposalExamplesModal from "@/views/proposal/proposal-edit/ActualProposalExamplesModal.vue";
import {argumentStore} from "@/store/argumentStore";

export default {
  name: "EditProposalView",
  props: {
    paramProposalId: {
      type: Number
    }
  },
  components: {
    EditProposalGeneralInfo,
    EditProposalEnterActual,
    EditProposalArguments,
    // EditProposalSubjects,
    EditProposalImportance,
    // EditProposalThumbnail,
    ActualProposalExamplesModal
  },
  data() {
    return {
      isProposal: false
    }
  },
  computed: {
    ...mapState(editProposalStore, [
      'editedProposalLoaded',
      'editedProposalData',
      'isDraftLoaded',
      'resetStoreData',
      'setActualProposalText',
      'editedProposalArguments',
      'autoSaveSavingStatus',
      'addProposalArgument'
    ]),
    ...mapState(proposalStore, [
      'actualExamplesModalState',
      'closeCreatePropFormView',
    ]),
  },
  methods: {
    ...mapActions(editProposalStore, [
      'getEditProposalInfo',
      'processProposalSaving',
      'setManuallySaveSavingState',
      'addNewArgument',
      'toggleProposalCantSavingModalState',
      'processProposalSaving',
      'setEditedProposalArguments',
      'toggleAlmostPublishModal'
    ]),
    ...mapActions(baseLoaderStore, [
      'showBaseLoader',
      'hideBaseLoader'
    ]),
    ...mapActions(proposalStore, [
      'setEditPropValue',
    ]),
    ...mapActions(argumentStore, [
      'getArguments',
    ]),
    ...mapActions(bankIdStore, [
      'checkBankIdAuthSession'
    ]),
    isValidToSave(proposalStatus) {
      let state = false;
      const $editProposalGeneralInfo = this.$refs.editProposalGeneralInfo;
      const $editProposalEnterActual = this.$refs.editProposalEnterActual;
      const $editProposalArguments = this.$refs.editProposalArguments;

      if (proposalStatus === 'DRAFT' || proposalStatus === 'PREVIEW') {
        $editProposalGeneralInfo.v$.$touch();

        state = !$editProposalGeneralInfo.v$.$invalid;
      } else if (proposalStatus === 'PUBLISH') {
        $editProposalGeneralInfo.v$.$touch();
        $editProposalEnterActual.v$.$touch();
        $editProposalArguments.validateArguments();

        state = (!$editProposalGeneralInfo.v$.$invalid &&
            !$editProposalEnterActual.v$.$invalid &&
            $editProposalArguments.readyForSave);
      }

      return state;
    },
    saveProposal(actionType, isManuallySave) {
      this.setManuallySaveSavingState(isManuallySave);
      if (this.isValidToSave(actionType)) {
        if (actionType === 'PREVIEW') {
          this.processProposalSaving(actionType);
        } else {
          this.checkBankIdAuthSession(() => {
            this.processProposalSaving(actionType);
          });
        }
      } else {
        if (this.isPublish) {
          this.toggleAlmostPublishModal();
        }
      }
    }
  },
  beforeMount() {
    this.isPublish = getUrlParameter('publish') === 'true';

    const proposalId = this.paramProposalId || ((this.editedProposalData ? this.editedProposalData.id : null) || this.$route.params.id);
    this.setActualProposalText('');
    this.getEditProposalInfo(proposalId).then(()=> {

      //get arguments
      this.getArguments({
        page: 0,
        proposalIds: this.editedProposalData.id,
        size: 30,
        statuses: ["DRAFT", "CURRENT"]
      }).then((resp)=> {
        this.setEditedProposalArguments(resp.data.content);
        if (this.editedProposalArguments.length === 0) {
          this.addNewArgument(true);
        }

        if (!this.isPublish) {
          this.hideBaseLoader();
        }  else {
          this.hideBaseLoader();
          this.saveProposal('PUBLISH');
        }
      })
    });
  },
  beforeUnmount() {
    this.resetStoreData();
    this.closeCreatePropFormView();
    this.setActualProposalText('');
    setUrlParam('publish', false);
  }
}
</script>

<template>
  <div class="edit-proposal-view-wrap">
    <div v-if="editedProposalLoaded" class="edit-proposal-view">
      <edit-proposal-general-info ref="editProposalGeneralInfo"/>
      <edit-proposal-enter-actual ref="editProposalEnterActual"/>
      <edit-proposal-arguments ref="editProposalArguments"/>
<!--      <edit-proposal-subjects-->
<!--          :subjects-list="editedProposalData.subjects"-->
<!--      />-->
      <edit-proposal-importance/>
<!--      <edit-proposal-thumbnail/>-->
    </div>
    <actual-proposal-examples-modal :dialog-state="actualExamplesModalState"/>
  </div>
</template>

<style lang="scss">
.edit-proposal-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 150px;
  background: #E9EAED;
}

.edit-prop-section {
  width: 970px;
  margin-bottom: 10px;
  padding: 15px;
  background: #fff;
  box-sizing: border-box;
  box-shadow: 0 2px 8px 0 rgba(79, 79, 79, 0.15);

  &__title {
    margin-bottom: 25px;
    font-size: 16px;
    font-weight: 600;
    color: #4f4f4f
  }
}

</style>